import { Injectable } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { Storager } from './storager';

@Injectable({
  providedIn: 'root'
})
export class SessionStoragerService implements Storager{

  public constructor() {
  }

  public setElement(key: string, obj: any, encoded?: boolean) {
    var jsonObj = JSON.stringify(obj);
    if (encoded) {
      jsonObj = btoa(jsonObj);
    }
    localStorage.setItem(key, jsonObj);
  }

  public getElement(key: string, encoded?: boolean): any {
    var element = localStorage.getItem(key);
    if (encoded) {
      element = atob(element);
    }
    return JSON.parse(element);
  }

  public removeElement(key: string) {
    localStorage.removeItem(key);
  }

  public clearAll() {
    localStorage.clear();
  }

  public hasElement(key: string): boolean {
    return !isNullOrUndefined(localStorage.getItem(key));
  }

}
